import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import Box from '@mui/material/Box';

import { AreaChart } from '../../shared/charts';

import '../dashboard.scss';

const FutureCasesChart = ({ cases = [] }) => {
  const buildFutureCasesData = (cases) => {
    const today = moment();

    let next7 = 0;
    let next14 = 0;
    let next30 = 0;

    cases.forEach((c) => {
      if (!c?.date) return;

      const surgeryDate = moment(c.date);
      const diff = surgeryDate.diff(today, 'days');

      if (diff >= 0 && diff <= 7) next7++;
      if (diff > 7 && diff <= 14) next14++;
      if (diff > 14 && diff <= 30) next30++;
    });

    return [
      { name: 'Next 7 Days', Cases: next7 },
      { name: 'Next 14 Days', Cases: next14 },
      { name: 'Next 30 Days', Cases: next30 },
    ];
  };

  const data = useMemo(() => {
    return buildFutureCasesData(cases);
  }, [cases]);

  return (
    <Box className="dashboard-graph-container">
      <div className="table-title-container">
        <div className="flex-1">
          <div className="d-flex">
            <Box>
              <Box className="table-title">
                Future Cases
                {/*<Box className="badge">timeline</Box>*/}
              </Box>

              <Box className="table-subtitle">
                Upcoming surgery dates
              </Box>
            </Box>
          </div>
        </div>
      </div>

      <Box sx={{ padding: '0 24px 8px 0' }}>
        <AreaChart
          data={data}
          datasets={[
            {
              key: 'Cases',
            },
          ]}
        />
      </Box>
    </Box>
  );
};

FutureCasesChart.propTypes = {
  cases: PropTypes.array,
};

export default memo(FutureCasesChart);